export default {
  en: 'English',
  it: 'Italiano',
  de: 'Deutsch',
};
